export default "__VITE_ASSET__lDpuJKFW__"